export const calcularRango = (nivel) => {

    if (nivel >= 80) return "Ascendido";
    if (nivel >= 60) return "Visionario";
    if (nivel >= 40) return "Estratega";
    if (nivel >= 20) return "Explorador";
  
    return "Iniciado";
  };
  
  export const calcularCorrupcion = ({
    precision,
    velocidad,
    streakFallos
  }) => {
  
    let corrupcion = 0;
  
    // mala precisión
    if (precision < 40) corrupcion += 35;
    else if (precision < 60) corrupcion += 20;
  
    // lentitud
    if (velocidad > 120) corrupcion += 20;
  
    // racha de errores
    corrupcion += streakFallos * 5;
  
    return Math.min(corrupcion, 100);
  };
  
  export const calcularNivel = ({
    preguntasRespondidas,
    precision
  }) => {
  
    const base = preguntasRespondidas * 0.5;
    const bonusPrecision = precision * 0.5;
  
    return Math.round(base + bonusPrecision);
  };